import { Reducer } from "react";
import { FrontendPermissions } from "../config/FrontendPermissions";

interface State {
    user: User,
    users: User[]
    token: any,
    isLoading: boolean,
    isEditing: boolean,
    permissions: Permissions[]
    frontendPermissions: FrontendPermissions[]
}

const initialState: State = {
    user: null,
    token: null,
    isLoading: false,
    isEditing: false,
    permissions: [],
    users: [],
    frontendPermissions: []
}

export enum AuthActions {
    RequestLogin = 'REQUEST_LOGIN',
    SetUser = 'SET_USER',
    SetUsers = 'SET_USERS',
    SetToken = 'SET_TOKEN',
    Logout = 'LOGOUT',
    SetIsAdmin = 'SET_IS_ADMIN',
    SetPermissions = 'SET_PERMISSIONS',
    SetFrontendPermissions = 'SET_FRONTEND_PERMISSIONS'
}

const reducer: Reducer<State, { type: AuthActions, payload: any }> = (state: State = initialState, { type, payload }): State => {
    switch (type) {
        case AuthActions.RequestLogin:
            return { ...state, isLoading: true }
        case AuthActions.SetToken:
            return { ...state, isLoading: false, token: payload }
        case AuthActions.SetUser:
            return { ...state, user: payload }
        case AuthActions.SetUsers:
            return { ...state, users: payload }
        case AuthActions.Logout:
            return { ...state, token: null }
        case AuthActions.SetIsAdmin:
            return { ...state, isEditing: payload }
        case AuthActions.SetPermissions:
            return { ...state, permissions: payload }
        case AuthActions.SetFrontendPermissions:
            return { ...state, frontendPermissions: payload }
        default:
            return state;
    }
}

export default reducer